// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"7":"a1b843a798e447f93f4f","527":"124e0afdd3dadbb9f546","640":"6947d4b0d5ef9ee0fef3"}[chunkId] + ".js";
};